export default {
  TOGGLE_VISIBILITY_SHORTCUT_ALERT (state) {
    state.alertShortcutMenuIsVisible = !state.alertShortcutMenuIsVisible;
  },
};
